
import MDBox from "dashboard/components/MDBox";
import MDTypography from "dashboard/components/MDTypography";
import IconButton from "@mui/material/IconButton";

import { Container, Grid, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';

import SearchAutoComplete from 'dashboard/components/Costum/AutoComplete/Search';
import DownloadIcon from "assets/images/layers-2x.png"; 

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: 50,
  border : `1px solid rgb(76,110, 137)`,
  backgroundColor:   "rgba(25, 87, 137 , .7)",
  '&:hover': {
    backgroundColor:  "rgb(25, 87, 137)",
  },
  marginLeft: 0,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    flexGrow: 1
  },
  height : "44px"
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color:"white"
}));

const FancyDivider = ({lang, direction,parseContent}) => {
	const placeHolder = {
		fr: {
			catchPhrase: "Trouvez nos solutions",
			downlaod: "Télécharger notre guide grand public"
		},
		ar: {
			catchPhrase: "اكتشف حلولنا",
			downlaod: "تحميل دليلنا العام"
		},
		en: {
			catchPhrase: "Find our solutions",
			downlaod: "Download our public guide"
		}
	};

	const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_PUBLIC_URL}/downloads/guide.pdf`; // path to your file (can be public or blob)
    link.download = "guide.pdf"; // optional: rename file
    link.click();
  };

  return (
			<MDBox className="cta-section" sx={{background : `url(${process.env.REACT_APP_PUBLIC_URL}/img/funfact-bg.jpg) center center`, minHeight:"300px", p:{xs:"40px", md:"80px", lg :"120px"}}}>
				<Container className="cta-section-item" sx={{position:"relative", p:{xs:"30px !important", md:"60px !important", lg :"90px !important"}}} >
					<Grid container spacing={2}>
						<Grid item xs={12}	md={6} lg={7}>
							<MDTypography color="white" variant="h1" sx={{fontSize : "43px"}}>{placeHolder[lang] ? placeHolder[lang].catchPhrase : placeHolder.fr.catchPhrase}</MDTypography>
							<Search>
									<SearchIconWrapper>
										<SearchIcon fontSize="medium" />
									</SearchIconWrapper>
									<SearchAutoComplete dir={direction} lang={lang} parseContent={parseContent} />
							</Search>
						</Grid>
						<Grid item xs={12}	md={6} lg={5} display="flex" justifyContent="center" alignItems="center">
							<Divider
                orientation="vertical"
                flexItem
                sx={{ display: { xs: "none", md: "block" }, mx: 2 }}
              />
							<Grid container justifyContent="center"  alignItems="center">
								<Grid item xs={12} >
									<MDTypography textAlign="center" color="white" variant="caption" m={2} sx={{fontSize : "16px", fontWeight :"bold", display:"block", width:"100%"}}>{placeHolder[lang] ? placeHolder[lang].downlaod : placeHolder.fr.downlaod}</MDTypography>
								</Grid>
								<Grid sx={{textAlign:"center"}}item xs={12} justifyContent="center" >
									<IconButton
										onClick={handleDownload}
										sx={{ padding: 2, "&:hover": { backgroundColor: "transparent" } }}
										aria-label="Download"
									>
										<MDBox
											component="img"
											src={DownloadIcon}
											alt="Download"
											sx={{ width: 64, height: 64 }}
										/>
									</IconButton>
								</Grid>
							</Grid>
						</Grid>
					</Grid>
					<MDBox className="cta-shape">
						<svg style={{fill: "#0465ac", verticalAlign: "middle"}} width="325.000000pt" height="267.000000pt" viewBox="0 0 325.000000 267.000000" preserveAspectRatio="xMidYMid meet"><g transform="translate(0.000000,267.000000) scale(0.100000,-0.100000)" stroke="none"><path d="M0 1332 l0 -1332 920 0 919 0 39 53 c213 291 233 519 64 720 -101 119 -201 194 -617 462 -344 222 -452 297 -605 426 -320 268 -528 547 -676 906 -20 48 -38 90 -40 92 -2 2 -4 -595 -4 -1327z"></path></g></svg>
					</MDBox>
				</Container>
			</MDBox>
  );
};
export default FancyDivider;